/* eslint-disable no-console */
<template>
  <div id="hamburguer-btn" class="container" @click="toggle()">
    <div class="bar1"></div>
    <div class="bar2"></div>
    <div class="bar3"></div>
  </div>
</template>
<script>
export default {
  data() {
    return {
      menu: false
    };
  },
  props: ["value"],
  watch: {
    value(val) {
      if (val != this.menu) {
        this.updateIcon(val);
        this.menu = val;
      }
    }
  },
  mounted() {
    this.updateIcon(this.value);
  },
  methods: {
    toggle() {
      this.menu = !this.menu;
      // eslint-disable-next-line no-console
      this.$emit("toggleMenu", this.menu);
      this.updateIcon(this.menu);
    },
    updateIcon(newStatus) {
      const element = document.getElementById("hamburguer-btn");
      if (element.classList.contains("change") && newStatus == false) {
        element.classList.toggle("change");
      } else {
        if (!element.classList.contains("change") && newStatus == true) {
          element.classList.toggle("change");
        }
      }
      // this.menu = newStatus;
    }
  }
};
</script>
<style style="scss" scoped>
.container {
  display: inline-block;
  cursor: pointer;
  width: 30px !important;
  height: 30px !important;
  display: flex !important;
  flex-direction: column;
  justify-content: space-around !important;
}
div {
  padding: 0px !important;
}
.bar1,
.bar2,
.bar3 {
  width: 100% !important;
  height: 4px !important;
  background-color: white;
  /* margin: 6px 0; */
  transition: 0.4s;
}

.change .bar1 {
  -webkit-transform: rotate(-45deg) translate(-9px, 6px);
  transform: rotate(-45deg) translate(-9px, 6px);
  background-color: red;
}

.change .bar2 {
  opacity: 0;
  background-color: red;
}

.change .bar3 {
  -webkit-transform: rotate(45deg) translate(-7px, -6px);
  transform: rotate(45deg) translate(-7px, -6px);
  background-color: red;
}
</style>
